import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import { SlotList } from '../index'

const template = {
  MAPPINGS: {
    DOM: {
      DESKTOP: {},
      MOBILE: {}
    },
    INTL: {
      DESKTOP: {},
      MOBILE: {}
    }
  }
}

export const Kargo = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  const KARGO = { ...template, ...VENDOR }
  const { MAPPINGS } = KARGO
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  const displayMappingsTable = () => {
    return (
      <Table size='small' aria-label='kargo-unit-mapping-table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6'>Mappings</Typography></TableCell>
            <TableCell>Domestic</TableCell>
            <TableCell>International</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Desktop</TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='KARGO.MAPPINGS.DOM.DESKTOP'
                object={MAPPINGS.DOM.DESKTOP}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Inventory Code'
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='KARGO.MAPPINGS.INTL.DESKTOP'
                object={MAPPINGS.INTL.DESKTOP}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Inventory Code'
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Mobile</TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='KARGO.MAPPINGS.DOM.MOBILE'
                object={MAPPINGS.DOM.MOBILE}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Inventory Code'
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='KARGO.MAPPINGS.INTL.MOBILE'
                object={MAPPINGS.INTL.MOBILE}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
                valueName='Inventory Code'
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='kargo-panel-content'
        id='kargo-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>Kargo</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>{displayMappingsTable()}</Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
